import { AbstractControl, ValidatorFn } from '@angular/forms';

export function minDateValidator(minDate: Date): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return null;

    const inputDate = new Date(control.value);
    const min = new Date(minDate);

    // Normalize both dates to midnight to ignore time part
    inputDate.setHours(0, 0, 0, 0);
    min.setHours(0, 0, 0, 0);

    return inputDate >= min ? null : { minDate: { required: min.toISOString().split('T')[0] } };
  };
}
